import {
	HealthBookingEnum,
	TelehealthBookingEnum,
	OdontoBookingEnum,
	ExamBookingEnum,
} from 'presentation/constants';
import {FlowEnum} from './flowEnum';

export const REBOOKING_PATH = {
	[FlowEnum.HEALTH]: HealthBookingEnum.HEALTH_BOOKING_FLOW,
	[FlowEnum.TELEHEALTH]: TelehealthBookingEnum.TELEHEALTH_BOOKING_FLOW,
	[FlowEnum.ODONTO]: OdontoBookingEnum.ODONTO_BOOKING_FLOW,
	[FlowEnum.EXAM]: ExamBookingEnum.EXAM_BOOKING_FLOW,
};
